import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import logo from "../assets/logo.png";
import PropostaPrintTemplate from "../components/PropostaPrintTemplate";
import "./ValidarProposta.css";

function ValidarProposta() {
  const { token } = useParams();
  const [carregando, setCarregando] = useState(true);
  const [proposta, setProposta] = useState(null);
  const [erro, setErro] = useState("");

  const [documento, setDocumento] = useState("");
  const [validando, setValidando] = useState(false);
  const [erroValidacao, setErroValidacao] = useState("");
  const [aguardarSegundos, setAguardarSegundos] = useState(0);
  const [dadosCompletos, setDadosCompletos] = useState(null);

  useEffect(() => {
    let ativo = true;
    axios
      .get(`/api/proposta-publica/${token}`)
      .then((res) => {
        if (ativo) setProposta(res.data);
      })
      .catch((err) => {
        if (ativo) setErro(err.response?.data?.erro || "Proposta não encontrada ou inválida.");
      })
      .finally(() => {
        if (ativo) setCarregando(false);
      });
    return () => {
      ativo = false;
    };
  }, [token]);

  useEffect(() => {
    if (aguardarSegundos <= 0) return;
    const id = setInterval(() => {
      setAguardarSegundos((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(id);
  }, [aguardarSegundos]);

  function handleSubmitDocumento(e) {
    e.preventDefault();
    if (validando || aguardarSegundos > 0 || documento.length !== 4) return;

    setValidando(true);
    setErroValidacao("");

    axios
      .post(`/api/proposta-publica/${token}/validar-documento`, { documento })
      .then((res) => {
        setDadosCompletos(res.data);
      })
      .catch((err) => {
        const dados = err.response?.data;
        if (err.response?.status === 429) {
          setAguardarSegundos(dados?.aguardarSegundos || 30);
        }
        setErroValidacao(dados?.erro || "Documento não confere.");
      })
      .finally(() => {
        setValidando(false);
      });
  }

  return (
    <div className="validar-container">
      <div className="validar-box">
        <img src={logo} alt="Logo Grupo Serbom" className="validar-logo" />

        <h2>Validação de Proposta</h2>

        {carregando && (
          <p className="validar-mensagem">
            <span className="spinner"></span>
          </p>
        )}

        {!carregando && proposta && (
          <>
            <div className="validar-selo ok">✓</div>
            <p className="validar-codigo">Proposta {proposta.codigo}</p>
            <p className="validar-empresa">{proposta.empresaNome}</p>
            <p className="validar-mensagem">Documento emitido por este sistema.</p>

            {!dadosCompletos && (
              <form className="validar-doc-form" onSubmit={handleSubmitDocumento}>
                <label htmlFor="validar-doc-input">
                  Para ver os detalhes completos, informe os 4 últimos caracteres do CPF ou CNPJ de uma das partes da proposta:
                </label>
                <input
                  id="validar-doc-input"
                  type="text"
                  inputMode="text"
                  maxLength={4}
                  placeholder="0000"
                  value={documento}
                  onChange={(e) =>
                    setDocumento(
                      e.target.value
                        .toUpperCase()
                        .replace(/[^0-9A-Z]/g, "")
                        .slice(0, 4),
                    )
                  }
                  disabled={validando || aguardarSegundos > 0}
                />
                <button type="submit" disabled={validando || aguardarSegundos > 0 || documento.length !== 4}>
                  {aguardarSegundos > 0 ? `Aguarde ${aguardarSegundos}s` : validando ? "Validando..." : "Validar"}
                </button>
                {erroValidacao && <p className="validar-doc-erro">{erroValidacao}</p>}
              </form>
            )}
          </>
        )}

        {!carregando && !proposta && (
          <>
            <div className="validar-selo erro">✕</div>
            <p className="validar-mensagem erro">{erro}</p>
          </>
        )}
      </div>

      {dadosCompletos && (
        <div className="validar-preview-wrapper">
          <PropostaPrintTemplate proposta={dadosCompletos} quadroResumo={dadosCompletos.quadroResumo} />
        </div>
      )}
    </div>
  );
}

export default ValidarProposta;
